export default __webpack_public_path__ + "static/media/Partner-Dhulikhel.6b4b8f99.png";